// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const linkContentProps = {
    /**
     * Link's label (text to render).
     */
    label: {
        type: String,
        required: false
    }
};
